/* The LIVE theme ships the same neutral token names for both themes and defaults to the dark
   stage. This remap re-points the neutral tokens to their light/inverse variants so a subtree
   renders as a white "light-island" (dark text on white) while brand/state colors stay intact.
   Shared by the ticket card (cardInner), the bottom sheets (SheetShell panel) and the QR-zoom
   overlay — apply it to the element that owns the surface `background: var(--color-bg-base)`. */
export const lightIsland = `
    --color-bg-base: var(--color-bg-base-alt);
    --color-text-default: var(--color-text-inverse-default);
    --color-text-subtle: var(--color-text-inverse-subtle);
    --color-border-default: var(--color-border-inverse-default);
    --color-border-subtle: var(--color-border-inverse-subtle);
    --color-bg-surface-default: var(--color-bg-surface-inverse-default);
    --color-bg-surface-hover: var(--color-bg-surface-inverse-hover);
    --color-bg-surface-selected: var(--color-bg-surface-inverse-selected);
    --color-bg-surface-disabled: var(--color-bg-surface-inverse-disabled);
`;
